var _path, _path2, _rect, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.5H15",
    stroke: "#1819B4",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.41797H14.1667",
    stroke: "#1819B4",
    strokeWidth: 1.875,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.66669,
    y: 1.5,
    width: 16.6667,
    height: 15,
    rx: 6.25,
    stroke: "#1819B4",
    strokeWidth: 1.875,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 12.3346C5.17361 10.1837 8.92684 10.0422 10 12.3346",
    stroke: "#1819B4",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75002 6.4987C8.75002 7.41917 8.00383 8.16536 7.08335 8.16536C6.16288 8.16536 5.41669 7.41917 5.41669 6.4987C5.41669 5.57822 6.16288 4.83203 7.08335 4.83203C8.00383 4.83203 8.75002 5.57822 8.75002 6.4987Z",
    stroke: "#1819B4",
    strokeWidth: 1.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activityIcon.1bd4ff3fa0fcdd8b7c0fa2b6f4ea8221.svg";
export { ForwardRef as ReactComponent };